<template>
  <!-- Footer -->
  <footer class="footer footer-one">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-2">
           <div class="footer-widget">
  <div class="footer-logo">
    <img 
      src="@/assets/icons/NextSense Logo white.svg" 
      alt="Logo"
      style="width:185px; height:60px;"
    />
  </div>
</div>

          </div>

          <div class="col-6">
            <div class="footer-widget">
             
             <div class="subscribe-bar">
  <input 
    type="email" 
    placeholder="Subscribe to our newsletter"
    class="subscribe-input"
    
  />
 <button class="subscribe-btn">
    <img 
      src="@/assets/icons/Right Arrow White.svg"
      alt="Right Arrow"
      style="width:20px; height:20px; object-fit:contain;"
    />
  </button>
</div>


            </div>
          </div>
        </div>

        <div class="row row-gap-4 mt-2">
          <div class="col-lg-2 col-md-3 col-sm-6">
            <div class="footer-widget footer-menu">
              <h5 class="footer-title">
                <div class="social-icon mt-2">

                  <a href="javascript:void(0);" class="me-3">
                    <img
                      src="@/assets/icons/facebook.png"
                      alt="Facebook"
                      style="width: 23px; height: 23px; object-fit: contain"
                    />
                  </a>

                  <a href="javascript:void(0);" class="me-3">
                    <img
                      src="@/assets/icons/LinkedIn.png"
                      alt="Facebook"
                      style="width: 23px; height: 23px; object-fit: contain"
                    />
                  </a>

                   <a href="javascript:void(0);" class="me-3"
                    ><img
                      src="@/assets/icons/YouTube.png"
                      alt="Instagram"
                      style="width: 23px; height: 23px; object-fit: contain"
                    />
                  </a>

                  <a href="javascript:void(0);" class="me-3">
  <span
    style="
      display: inline-flex;
      width: 23px;
      height: 23px;
      border: 2px solid #fff;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      color: #fff;
    "
  >
    <i class="fa-brands fa-x-twitter"></i>
  </span>
</a>


                  <a href="javascript:void(0);" class="me-3"
                    ><img
                      src="@/assets/icons/Instagram.png"
                      alt="Instagram"
                      style="width: 23px; height: 23px; object-fit: contain"
                    />
                  </a>

                 

                 
                </div>
              </h5>
              <div class="row g-2 mt-3">
                <div class="col-6">
                  <img
                    src="@/assets/img/Rectangle_415.png"
                    alt="Rectangl"
                    class="img-fluid"
                  />
                </div>
                <div class="col-6">
                  <img
                    src="@/assets/img/Rectangle_4152.png"
                    alt="Rectangl"
                    class="img-fluid"
                  />
                </div>
                <div class="col-12 mt-4">
                  <img
                    src="@/assets/img/Rectangle4143.png"
                    alt="Rectangl"
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Quick Links Section -->
          <div class="col-lg-2 col-md-3 col-sm-6">
            <div class="footer-widget footer-menu">
              <h5 class="footer-title">Quick Links</h5>
              <ul>
                <li><a href="javascript:void(0);">Careers</a></li>
                <li><a href="javascript:void(0);">Make a referral</a></li>
                <li><a href="javascript:void(0);">Feedback</a></li>
                <li>
                  <a href="javascript:void(0);"
                    >Services guides and handbooks</a
                  >
                </li>
                <li><a href="javascript:void(0);">Policies</a></li>
              </ul>
            </div>
          </div>

          <!-- Contact Section -->
          <div class="col-lg-2 col-md-3 col-sm-6">
            <div class="footer-widget footer-menu">
              <h5 class="footer-title">Contact</h5>
              <ul>
                <li><a href="javascript:void(0);">Locations</a></li>
                <li>
                  <a href="javascript:void(0);"
                    >New enquiries <br />
                    Client care <br />
                    190 043 727</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);">Fundraising and <br> donations</a>
                </li>
                <li>
                  <a href="javascript:void(0);"
                    >Supporter care <br />
                    1800 043 411</a
                  >
                </li>
              </ul>
            </div>
          </div>

          <!-- Resources Section -->
          <div class="col-lg-2 col-md-3 col-sm-6">
            <div class="footer-widget footer-menu">
              <h5 class="footer-title">Resources</h5>
              <ul>
                <li><a href="javascript:void(0);">News</a></li>
                <li><a href="javascript:void(0);">Newsletters</a></li>
                <li><a href="javascript:void(0);">Events</a></li>
                <li><a href="javascript:void(0);">Research</a></li>
                <li><a href="javascript:void(0);">Support</a></li>
              </ul>
            </div>
          </div>

          <!-- About Section -->
          <div class="col-lg-2 col-md-3 col-sm-6">
            <div class="footer-widget footer-menu">
              <h5 class="footer-title">About</h5>
              <ul>
                <li><a href="javascript:void(0);">Our History</a></li>
                <li><a href="javascript:void(0);">Our People</a></li>
                <li><a href="javascript:void(0);">Careers</a></li>
                <li><a href="javascript:void(0);">Governance</a></li>
                <li><a href="javascript:void(0);">Feedback</a></li>
                <li><a href="javascript:void(0);">Centre of innovation</a></li>
              </ul>
            </div>
          </div>

          <div class="col-lg-2 col-md-3 col-sm-6">
            <div class="footer-widget footer-menu">
              <h5 class="footer-title">Get Involved</h5>
              <ul>
                <li>
                  <a href="javascript:void(0);">Leave a Gift in your <br> will</a>
                </li>
                <li><a href="javascript:void(0);">Committees</a></li>
                <li>
                  <a href="javascript:void(0);">Corporate partnerships</a>
                </li>
                <li><a href="javascript:void(0);">Grant funding</a></li>
                <li><a href="javascript:void(0);">Become a volunteer</a></li>
                <li>
                  <a href="javascript:void(0);">Fundraise for <br> NextSense</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Acknowledgement Section -->
        <div class="row mt-3">
          <div class="col-12">
            <div class="acknowledgement mb-3">
              <p>
                We acknowledge Aboriginal and Torres Strait Islander peoples as
                the first peoples and the Traditional Owners and Custodians of
                the lands and waters on which we live and work. We pay our
                respects to their Elders, Knowledge Holders and Leaders, past
                and present and extend that respect to all Aboriginal and Torres
                Strait Islander peoples.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="container">
        <div class="row align-items-center row-gap-2">
          <div class="col-lg-6">
            <div class="text-center text-lg-start">
              <p>
                ABN 53 443 272 865 |
                <a href="javascript:void(0);">Terms and Conditions</a> |
                <a href="javascript:void(0);">Privacy Policy</a>
              </p>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="text-center text-lg-end">
              <p>© Copyright NextSense | All rights reserved</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- /Footer -->
</template>

<style scoped>
.footer {
  background-color: #f8f9fa;
  color: #333;
  padding-top: 40px;
}

.footer.footer-one .footer-top {
  padding: 0px 0;
}

.footer-title {
  font-weight: 600;
  margin-bottom: 15px;
  font-size: 16px;
  color: #2c3e50;
}

.footer-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-menu ul li {
  margin-bottom: 8px;
}

.footer-menu ul li a {
  color: #555;
  text-decoration: none;
  transition: color 0.3s;
  font-size: 14px;
}

.footer-menu ul li a:hover {
  color: #007bff;
}

.footer-newsletter .subscribe-form {
  display: flex;
  margin-bottom: 15px;
}

.footer-newsletter .form-control {
  border-radius: 4px 0 0 4px;
  border: 1px solid #ddd;
  padding: 10px 15px;
  flex: 1;
}

.footer-newsletter .btn {
  border-radius: 0 4px 4px 0;
  padding: 10px 20px;
  background-color: #007bff;
  border: 1px solid #007bff;
  color: white;
}

.acknowledgement {
  padding-top: 10px;
  border-top: 1px solid #ddd;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.footer-bottom {
  background-color: #e9ecef;
  padding: 15px 0;
  border-top: 1px solid #ddd;
}

.footer-bottom p {
  margin: 0;
  font-size: 13px;
  color: #555;
}

.footer-bottom a {
  color: #555;
  text-decoration: none;
}

.footer-bottom a:hover {
  color: #007bff;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .footer-newsletter .subscribe-form {
    flex-direction: column;
  }

  .footer-newsletter .form-control {
    border-radius: 4px;
  }

  .footer-newsletter .btn {
    border-radius: 4px;
    width: 100%;
  }

  .footer-menu {
    margin-bottom: 20px;
  }
}

.subscribe-bar {
  width: 100%;
  border: 1.5px solid #fff;
  padding: 0px 18px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  background: transparent;
  color: #fff;
  gap: 10px;
}

.subscribe-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 15px;
  padding: 12px 0;        /* 👈 vertically center */
  line-height: 1;         /* 👈 perfect alignment */
}


.subscribe-input::placeholder {
  color: #ccc;
}

.subscribe-btn {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  font-weight: 400;
}

.subscribe-btn:hover {
  opacity: 0.7;
}


</style>
